import React from "react";
import { Link, LinkProps } from "react-router-dom";

export const LinkBehavior = React.forwardRef<
  any,
  Omit<LinkProps, "to"> & { href: LinkProps["to"] }
>(function LinkBehavior(props, ref) {
  const { href, children, ...other } = props;
  if (href && href.toString().indexOf("http") === 0) {
    return (
      <a ref={ref} href={href.toString()} {...other}>
        {children}
      </a>
    );
  } else {
    return (
      <Link ref={ref} to={href} {...other}>
        {children}
      </Link>
    );
  }
});
